<template>
    <div class="apprentice-simple-card student-group-management">
        <h4 class="title">{{ $t('assignment.partner.confirm_group_for_assignment') }} "{{ assignmentIn.name }}"</h4>

        <p class="description">
            <span class="student">{{ groupLeader.user.full_name }}</span>
            {{ $t('assignment.partner.invited_you_to_collaborate_on') }} {{ assignmentIn.name }}
        </p>

        <b-button
            class="btn-decline"
            variant="outline-danger"
            @click="deny()"
            >{{ $t('assignment.partner.refuse') }}</b-button
        >
        <b-button
            class="btn-confirm"
            variant="primary"
            @click="confirm()"
            >{{ $t('common.confirm') }}</b-button
        >
    </div>
</template>

<script>
export default {
    name: 'design-2021-assignment-partner-confirm-component',
    props: {
        assignmentIn: Object,
        assignmentPartnerIn: Object,
    },
    data() {
        return {
            groupLeader: this.assignmentPartnerIn.assignment_partner_users.find(
                (assignmentPartnerUser) => assignmentPartnerUser.user_id === this.assignmentPartnerIn.user_id,
            ),
        };
    },
    methods: {
        confirm() {
            this.alert.saving();
            const assignmentPartnerUser = this.assignmentPartnerIn.assignment_partner_users.find(
                (assignmentPartnerUser) => assignmentPartnerUser.user_id === this.$authUser.id,
            );
            this.axios.post(this.routes.assignmentPartnerUserConfirm(assignmentPartnerUser.id)).then(
                (response) => {
                    window.location.reload();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        deny() {
            this.alert.saving();
            const assignmentPartnerUser = this.assignmentPartnerIn.assignment_partner_users.find(
                (assignmentPartnerUser) => assignmentPartnerUser.user_id === this.$authUser.id,
            );
            this.axios.delete(this.routes.assignmentPartnerUserDeny(assignmentPartnerUser.id)).then(
                (response) => {
                    window.location.reload();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.student-group-management {
    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }

    .description {
        margin-bottom: $grid-gutter-width;
    }

    .student {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
        font-size: $base-font-size;
    }

    .btn {
        line-height: 1;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}
</style>
